import { applyMiddleware, combineReducers, compose, createStore } from 'redux';
import thunk from 'redux-thunk';
import { connectRouter, routerMiddleware } from 'connected-react-router';
import * as Identity from './Identity';
import * as Accounts from './Accounts';
import * as Notification from './Notification';
import * as Terminals from './Terminals'
import * as Shops from './Shops';
import * as SalesPromotions from './SalesPromotions';
import * as Merchants from './Merchants'
import * as Acquirers from './Acquirers'
import * as Trades from './Trades'
import * as Fees from './Fees'
import * as PayOffList from './PayOffList'
import * as ConfirmPayment from './ConfirmPayment'
import * as BankPayment from './BankPayment'
import * as CreditCardPayment from './CreditCardPayment'
import * as AdjustmentFeeList from './AdjustmentFeeList'
import * as PointManagements from './PointManagements'
import * as PointAggregates from './PointAggregates'
import * as Notices from './Notices';

export default function configureStore(history, initialState) {
    const reducers = {
        Identity: Identity.reducer,
        Accounts: Accounts.reducer,
        Notification: Notification.reducer,
        Terminals: Terminals.reducer,
        Shops: Shops.reducer,
        Merchants: Merchants.reducer,
        Acquirers: Acquirers.reducer,
        SalesPromotions: SalesPromotions.reducer,
        Trades: Trades.reducer,
        Fees: Fees.reducer,
        PayOffList: PayOffList.reducer,
        ConfirmPayment: ConfirmPayment.reducer,
        BankPayment: BankPayment.reducer,
        CreditCardPayment: CreditCardPayment.reducer,
        AdjustmentFeeList: AdjustmentFeeList.reducer,
        PointManagements: PointManagements.reducer,
        PointAggregates: PointAggregates.reducer,
        Notices: Notices.reducer,
    };

    const middleware = [
        thunk,
        routerMiddleware(history)
    ];

    // In development, use the browser's Redux dev tools extension if installed
    const enhancers = [];
    const isDevelopment = process.env.NODE_ENV === 'development';
    if (isDevelopment && typeof window !== 'undefined' && window.devToolsExtension) {
        enhancers.push(window.devToolsExtension());
    }

    const rootReducer = combineReducers({
        ...reducers,
        router: connectRouter(history)
    });

    return createStore(
        rootReducer,
        initialState,
        compose(applyMiddleware(...middleware), ...enhancers)
    );
}